import { API } from '../../lib/ortam';

// Müşteri paneli istekleri (2026-10-26) — yalnız /api/musteri/* (müşteri token'ı başka yolda 403
// `musteri_yetkisiz` alır; services/auth tokenDogrula varsayılan reddet kapısı). Hata gövdesi
// (`hata`, `red`, `red_nedeni`) Error üzerinde taşınır: sepet/sipariş reddi soru numaralarıyla gösterilir.
export function musteriApi(authFetch) {
  const iste = async (yol, { method = 'GET', govde } = {}) => {
    const r = await authFetch(`${API}/api/musteri${yol}`, {
      method, ...(govde !== undefined ? { body: JSON.stringify(govde) } : {}),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) {
      const e = new Error(j.hata || `İstek başarısız (HTTP ${r.status})`);
      e.durum = r.status;
      e.govde = j;
      throw e;
    }
    return j;
  };
  return {
    profil: () => iste('/profil'),
    kazanim: (ders, mufredat) => iste(`/kazanim?${new URLSearchParams({ ders, ...(mufredat ? { mufredat } : {}) })}`),
    sorular: (suzgec, sayfa) => iste(`/sorular?${sorguMetni(suzgec, sayfa)}`),
    sekil: (no) => iste(`/sorular/${no}/sekil`),
    sepet: () => iste('/sepet'),
    sepeteEkle: (nolar) => iste('/sepet', { method: 'POST', govde: { public_nolar: nolar } }),
    sepettenCikar: (no) => iste(`/sepet/${no}`, { method: 'DELETE' }),
    sepetiBosalt: () => iste('/sepet', { method: 'DELETE' }),
    siparisVer: (not) => iste('/siparis', { method: 'POST', govde: not ? { not } : {} }),
    siparisler: () => iste('/siparisler'),
    siparis: (id) => iste(`/siparisler/${id}`),
  };
}

/** Süzgeç durumu -> sorgu dizgisi (boş alan gönderilmez; puan listesi virgülle). */
export function sorguMetni(s, sayfa = 1) {
  const p = new URLSearchParams();
  if (s.ders) p.set('ders', s.ders);
  if (s.mufredat) p.set('mufredat', s.mufredat);
  if (s.kazanim) p.set('kazanim_kodu', s.kazanim);
  if (Array.isArray(s.puan) && s.puan.length) p.set('puan', s.puan.join(','));
  if (s.gorsel) p.set('gorsel', s.gorsel);
  if (s.baglam) p.set('baglam', s.baglam);
  if (s.q && s.q.trim().length >= 2) p.set('q', s.q.trim());
  if (sayfa > 1) p.set('sayfa', String(sayfa));
  return p.toString();
}
